import React from "react";
import { Pagination, Table } from "@culturehq/components";
import client from "@culturehq/client";

import { useProfile } from "app/context";
import { useFetch, usePagination } from "app/hooks";
import { Trans } from "app/utils";
import getBadgeTypes from "constants/getBadgeTypes";

import { TimeDiff } from "components/common/Time";

const PointIncrement = ({ pointIncrement, badgeTypes }) => {
  const badgeType = badgeTypes.find(({ key }) => key === pointIncrement.source);

  if (!badgeType) {
    // for instance, if the badge was for recognition but then recognition was
    // disabled
    return null;
  }

  return (
    <tr>
      <td>
        <div className="Badge">
          <img src={badgeType.image} alt={badgeType.past} />
          <span>+{pointIncrement.amount}</span>
        </div>
      </td>
      <td>
        <p>{pointIncrement.detail ? `${badgeType.detail} ${pointIncrement.detail}` : badgeType.past}</p>
      </td>
      <td>
        <TimeDiff time={pointIncrement.createdAt} />
      </td>
    </tr>
  );
};

const PointHistory = ({ user }) => {
  const { profile } = useProfile();
  const badgeTypes = getBadgeTypes(profile);

  const [page, onPageClick] = usePagination();
  const { fetching, json: { pagination = {}, pointIncrements = [] } } = useFetch(
    () => client.getUserPointIncrements({ page, userId: user.id }),
    [page, user]
  );

  return (
    <div className="User-Activity">
      <div className="clearfix box-shadow padding-15px">
        <div className="Points">
          <div className="History__row">
            <Table>
              <thead className="chart-header">
                <tr>
                  <th>
                    <Trans>Earned</Trans>
                  </th>
                  <th>
                    <Trans>Action</Trans>
                  </th>
                  <th>
                    <Trans>Date Earned</Trans>
                  </th>
                </tr>
              </thead>

              <tbody className="row chart-row badge-row">
                {pointIncrements.map(pointIncrement => (
                  <PointIncrement
                    key={`${pointIncrement.source}-${pointIncrement.createdAt}`}
                    pointIncrement={pointIncrement}
                    badgeTypes={badgeTypes}
                  />
                ))}
              </tbody>
            </Table>

            {!fetching && pointIncrements.length === 0 && (
              <div className="row chart-row">
                <div className="col-xs-12">
                  <Trans>No achievements earned</Trans>
                </div>
              </div>
            )}
            <Pagination {...pagination} onClick={onPageClick} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PointHistory;
